import React, { useEffect, useState } from "react";
import { Button, Card, Empty, Popconfirm, Space, Table } from "antd";
import axios from "axios";
import { Job } from "interfaces/jobs";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import Title from "antd/lib/typography/Title";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { message } from "components/Messages/Messages";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";

const ActiveJobs = () => {
  const [jobPostings, setJobPostings] = useState<Job[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { currentUser } = useLoginContext();
  const history = useHistory();

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<Job[]>(`/jobs/${currentUser?.id}/job-list/`)
      .then(response => {
        setJobPostings(
          response.data
            .filter(job => dayjs(job.deadline) >= dayjs())
            .sort((a, b) => dayjs(a.deadline).diff(dayjs(b.deadline)))
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [currentUser]);

  const columns = [
    {
      title: "Tittel",
      dataIndex: "title",
      width: "50%",
      ellipsis: true,
    },
    {
      title: "Søknadsfrist",
      dataIndex: "deadline",
      width: "15%",
      render: (deadline: string) => dayjs(deadline).format("DD.MM.YYYY"),
      ellipsis: true,
    },
    {
      title: "Visninger",
      dataIndex: "views",
      width: "12.5%",
      ellipsis: true,
    },
    {
      title: "Favoritter",
      dataIndex: "favorite_jobs_count",
      width: "12.5%",
    },
    {
      title: "",
      dataIndex: "",
      width: "10%",
      align: "right" as const,
      ellipsis: true,
      render: (job: Job) => (
        <Space>
          <Button
            type="text"
            shape="circle"
            icon={<EditOutlined />}
            onClick={event => {
              event.stopPropagation();
              history.push(`/company/company-profile/jobs/${job.id}/edit/`);
            }}
          />
          <Popconfirm
            title={`Er du sikker på at du vil slette stillingsannonsen "${job.title}"?`}
            okText="Slett"
            cancelText="Avbryt"
            okType="danger"
            onCancel={event => event?.stopPropagation()}
            onConfirm={event => {
              event?.stopPropagation();
              axios
                .delete<Job>(`/jobs/${currentUser?.id}/job-list/${job.id}/`)
                .then(() => {
                  message("success", "Stillingsannonsen er slettet");
                  setJobPostings(jobPostings.filter(j => j.id !== job.id));
                  history.push("/company/company-profile/jobs");
                })
                .catch(() => message("error", "Kunne ikke slette stillingsannonsen. Prøv igjen senere"));
            }}
          >
            <Button
              type="text"
              shape="circle"
              danger
              icon={<DeleteOutlined />}
              onClick={event => event.stopPropagation()}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Title level={5}>Aktive stillingsannonser</Title>
      <Card>
        <Table
          columns={columns}
          dataSource={jobPostings.filter(job => dayjs(job.deadline) >= dayjs())}
          size="small"
          rowKey="id"
          onRow={(_record, rowKey) => ({
            onClick: () => {
              if (rowKey === undefined) return null;
              history.push(`/jobs/${jobPostings[rowKey].id}`);
            },
          })}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen aktive stillingsannonser" />,
          }}
          loading={loading}
        />
      </Card>
    </>
  );
};

export default ActiveJobs;
